import {
  displayOnPrintValueLabel,
  displayOnScreenValueLabel,
  DISPLAY_SCREEN_PRINT,
  DISPLAY_SCREEN_NO_PRINT,
  DISPLAY_PRINT_NO_SCREEN,
  NO_DISPLAY_SCREEN_PRINT
} from '../constants';

export const getDefaultValueFromProp = (
  shoppingPreferencesImageSettings,
  prop = displayOnScreenValueLabel
) =>
  Array.isArray(shoppingPreferencesImageSettings) &&
  shoppingPreferencesImageSettings?.find(option => option?.value === prop)
    ?.default;

export const getUpdatedSchema = (
  shoppingPreferencesImageSettings,
  schema,
  isGuest
) => {
  const onScreenImagesPreference = getDefaultValueFromProp(
    shoppingPreferencesImageSettings,
    displayOnScreenValueLabel
  );
  const onPrintImagesPreference = getDefaultValueFromProp(
    shoppingPreferencesImageSettings,
    displayOnPrintValueLabel
  );

  let columClassName = DISPLAY_SCREEN_PRINT;
  if (!isGuest) {
    if (onScreenImagesPreference && !onPrintImagesPreference) {
      columClassName = DISPLAY_SCREEN_NO_PRINT;
    } else if (!onScreenImagesPreference && onPrintImagesPreference) {
      columClassName = DISPLAY_PRINT_NO_SCREEN;
    } else if (!onScreenImagesPreference && !onPrintImagesPreference) {
      columClassName = NO_DISPLAY_SCREEN_PRINT;
    }
  }

  return schema.map(column =>
    column?.id === 'image' ? { ...column, className: columClassName } : column
  );
};
